var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsscher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.8379 45.3576L123.379 29.1195M5.28418 98.2473L32.4883 82.4732M5.28418 98.2473L30.1685 123.047M5.28418 98.2473V28.7399M82.2148 95.8011L98.2842 123.047M98.2842 123.047L123.126 98.2895M98.2842 123.047H30.1685M28.8611 5.28956L45.2257 32.4093M45.2257 32.4093L32.5726 45.1467V82.4732L45.9427 95.8011H82.51L95.8379 82.4732M45.2257 32.4093H82.8896L95.8379 45.3154V82.4732M45.8583 95.8011L30.1685 123.047M99.0012 4.95215L82.8053 32.3671M99.0012 4.95215L123.126 29.0351L123.126 98.2895M99.0012 4.95215H28.8611L5.28418 28.7399M95.8379 82.4732L123.126 98.2895M5.28418 28.7399L32.91 45.3997M87.993 23.6787L104.526 40.1276V87.4922L87.5291 104.447H40.9236L23.8842 87.4922V39.9167L40.0379 23.6787H87.993ZM93.2652 14.8215L113.426 34.9399V92.7643L92.6747 113.473H35.7781L14.9849 92.7222V34.6446L34.6815 14.8215H93.2652Z",
    stroke: "#151542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsscher);
export default __webpack_public_path__ + "static/media/asscher.4201b753d0f084a0e8d45bd924e511f4.svg";
export { ForwardRef as ReactComponent };